// extracted by mini-css-extract-plugin
export default {"container":"listsView_container__IK8+r","titleList":"listsView_titleList__tJf-E","gridContainer":"listsView_gridContainer__UM-of"};